/**
 * A short burst of paper, for a new personal best — the one celebration a
 * student is given, and only the first time they see it.
 *
 * Eighteen small pieces, placed the same way every time (no randomness, so it
 * never lands badly), flying out over 900ms on the strong ease-out and gone.
 * Decoration only: hidden from screen readers, and not drawn at all for
 * someone who has asked for less motion.
 */
const PIECES = Array.from({ length: 18 }, (_, i) => {
  const angle = (i / 18) * Math.PI * 2 + (i % 2) * 0.18;
  const reach = 70 + ((i * 37) % 50);
  return {
    x: Math.cos(angle) * reach,
    y: Math.sin(angle) * reach * 0.75 - 18,
    r: ((i * 53) % 360) - 180,
    tone: ['var(--brand, #cf1a2b)', 'var(--ink, #17150f)', '#d9a441', 'var(--brand, #cf1a2b)'][i % 4],
    delay: (i % 6) * 18,
  };
});

export function Burst({ delay = 0 }: { delay?: number }) {
  return (
    <span className="burst" aria-hidden="true">
      {PIECES.map((p, i) => (
        <i
          key={i}
          style={
            {
              '--x': `${p.x.toFixed(0)}px`,
              '--y': `${p.y.toFixed(0)}px`,
              '--r': `${p.r}deg`,
              background: p.tone,
              animationDelay: `${delay + p.delay}ms`,
            } as React.CSSProperties
          }
        />
      ))}
    </span>
  );
}
